import React from 'react';
import VerifyEmailComponent from '../../Auth/verifyEmail';

export default function VerifyEmail() {
  return <VerifyEmailComponent />;
}
